import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  inputCell: {
    paddingTop: 0,
    paddingBottom: 0,
    '& input': {
      minWidth: '50px',
      maxWidth: '100px',
      padding: '14px 12px',
      textAlign: 'center',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      },
      mozAppearance: 'textfield'
    }
  }
});

const InputCell = props => {
  const { classes, key, value, onChange, onBlur, disabled, inputAdornment } = props;

  return <TableCell align="center" className={classes.inputCell} key={key}>
    <TextField
      type="number"
      step="0.01"
      value={value}
      placeholder="–"
      InputProps={inputAdornment && {
        endAdornment: <InputAdornment position="end">{inputAdornment}</InputAdornment>,
      }}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled ? disabled : false}
    />
  </TableCell>
}

export default withStyles(styles)(InputCell);


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/InputCell.js